import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export function formatRuDate(raw) {
    try {
        return format(new Date(raw), 'dd.MM.yyyy', { locale: ru });
    } catch {
        return 'Неверная дата';
    }
}
